import {FC, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router";
import {hideModal} from "modules/actions";
import {getIsOpenDontLosePicksModal} from "modules/selectors";
import {getUri} from "modules/utils";
import {ButtonsBox, ModalIcon, PrimaryExternalLink, SecondaryExternalLink} from "components";
import {ModalText, ModalTitle} from "./common";
import {BaseModal} from "./BaseModal";
import icon from "assets/images/modal/modal-warning-icon.svg";

export const DontLosePicksModal: FC = () => {
	const {t} = useTranslation();
	const location = useLocation();
	const dispatch = useDispatch();
	const isOpen = useSelector(getIsOpenDontLosePicksModal);

	const closeHandler = useCallback(() => {
		dispatch(hideModal("dontLosePicksModal"));
	}, [dispatch]);

	if (!isOpen) {
		return null;
	}

	return (
		<BaseModal handleClose={closeHandler}>
			<ModalIcon className="small" src={icon} alt="Warning" />
			<ModalTitle>{t("prediction.dont_lose_picks_modal.title")}</ModalTitle>
			<ModalText>{t("prediction.dont_lose_picks_modal.desc")}</ModalText>
			<ButtonsBox>
				<SecondaryExternalLink target="_self" href={getUri("login", location.pathname)}>
					{t("prediction.dont_lose_picks_modal.sign_in")}
				</SecondaryExternalLink>

				<PrimaryExternalLink
					target="_self"
					href={getUri("registration", location.pathname)}>
					{t("prediction.dont_lose_picks_modal.sign_up")}
				</PrimaryExternalLink>
			</ButtonsBox>
		</BaseModal>
	);
};
